class ActivityFeedPostForm {
  elements:any = {};
  options = {
    attachments: [],
    thickbox: false,
  };
  commitQueue = [];
  attachments = [];
  templates = {};
  formData = null;

  id = null;

  links = [];
  submitBlockers = [];

  constructor(mainElm, options:object) {
    let that = this;
    Object.assign(this.options, options);

    this.formData = new FormData();


    this.elements.main = jQuery(mainElm);
    this.elements.attachments = this.elements.main.find(".attachments");
    this.elements.imageAttachments = this.elements.main.find(".attachments>.images");
    this.elements.imageAttachmentsList = this.elements.main.find(".attachments>.images>ul");
    this.elements.addImageAttachment = this.elements.main.find(".attachments>.images .add");
    this.elements.linkAttachments = this.elements.main.find(".attachments>.links");
    this.elements.linkAttachmentsList = this.elements.main.find(".attachments>.links>ul");
    this.elements.form = this.elements.main.find('form');
    this.elements.content = this.elements.form.find('textarea');
    this.elements.submit = this.elements.form.find('button.do-submit');

    let idElm = this.elements.form.find('input[name=activityId]');
    if (idElm.length)
      this.id = idElm.val();
    


    this.attachments = JSON.parse(JSON.stringify(this.options.attachments));

    this.elements.form.on('submit', function(e) {
      e.preventDefault();
      that.submit();
    });

    let templates = {
      image: new ProplusTemplate(this.elements.main.find('.template-image-attachment')),
      link: new ProplusTemplate(this.elements.main.find('.template-link-attachment')),
      addImage: new ProplusTemplate(this.elements.main.find('.template-add-image-attachment')),
    };

    this.templates = templates;

    for (let attachment of this.attachments) {
      attachment.committed = true;
      attachment.delete = false;
      let rendered;
      switch (attachment.type) {
        case 'photo':
        case 'image':
          rendered = this.templates['image'].render(attachment);
          rendered.appendTo(this.elements.imageAttachmentsList);
        break;

        case 'link':
          let data = Object.assign({
            status: 'loaded',
          }, attachment);
          rendered = this.templates["link"].render(data);
          rendered.appendTo(this.elements.linkAttachmentsList);
          this.links.push(attachment.url);
        break;
      }
    }

    this.elements.imageAttachmentsList.on("click", ".add", function(e) {
      let $target = jQuery(e.target);
      if (!$target.is('input[type=file]')) {
        let parent = $target.is('.add') ? $target : $target.parents('.add');
        parent.find('input[type=file]').click();
      }
    });
    this.elements.addImageAttachment.find("input[type=file]").on("change", function () {
      that.attachImage(this);
      this.value = '';
    });

    this.elements.attachments.on("click", ".delete", function(e) {
      let $this = jQuery(this);
      let $attachment = $this.parents('.attachment');

      that.deleteAttachment($attachment.data('id'));
    });

    this.elements.content.on('keyup', function (e) {
      that.scanLinks([this.selectionStart, -1]);
    });
    this.elements.content.on('blur', function (e) {
      that.scanLinks();
    });

    let $attachmentActions = this.elements.main.find('form>.attachment-actions');
    $attachmentActions.find('.do-attach-image').click(function () {
      that.elements.imageAttachmentsList.find('.add').click();
    });

    $attachmentActions.find('.do-attach-link').click(function () {
      let url = prompt('Liitettävän linkin osoite');
      if (url)
        that.attachLink(url);
    });

    this.elements.main.find('.post-actions .do-submit').click(function () {
      that.submit();
    });
    this.elements.main.find('.post-actions .do-cancel').click(function () {
      that.close();
    });

    this.scanLinks([], false);
  }


  addSubmitBlocker(name) {
    if (this.submitBlockers.indexOf(name) != -1)
      return false;
    
    this.submitBlockers.push(name);
    this.elements.submit.attr("disabled", "disabled");
    return true;
  }

  removeSubmitBlocker(name) {
    let index = this.submitBlockers.indexOf(name);
    if (!this.submitBlockers.length)
      return false;

      
    if (index === -1)
      return false;
    this.submitBlockers.splice(index, 1);

    if (this.submitBlockers.length)
      this.elements.submit.attr('disabled', 'disabled');
    else
      this.elements.submit.attr('disabled', false);

    return true;
  }

  scanLinks(ignorePositions = [], add = true) {
    let content = this.elements.content.val();

    if (!content.trim()) {
      this.addSubmitBlocker("emptyContent");
    } else {
      this.removeSubmitBlocker("emptyContent");
    }

    let re = /(^|\s)(https?:\/\/[^\/:]+\.[a-z]+[^\s]+|www\.[^.]+\.[a-z]+[^\s]*)/gmi;
    let urls = [];
    let matches;

    for (let i = 0; i < ignorePositions.length; i++) {
      if (ignorePositions[i] < 0)
        ignorePositions[i] = content.length + ignorePositions[i] + 1;
    }

    while (matches = re.exec(content)) {
      let url = matches[2];
      console.log('match', url);
      let urlStart = matches.index + matches[1].length;
      let urlEnd = urlStart + url.length;

      console.log(url, urlStart, urlEnd);
      let ignored = false;
      for (let ignorePosition of ignorePositions) {
        console.log('ignorePosition', ignorePosition);
        if (ignorePosition >= urlStart && ignorePosition <= urlEnd) {
          ignored = true;
          console.log('ignorettu');
          break;
        } else {
          console.log('ei ignorettu', ignorePosition);
        }
      }
      if (ignored)
        continue;

      if (urls.indexOf(url) == -1) {
        urls.push(url);
      }
    }

    console.log('Skannataan linkkejä', urls);
    if (add) {
      for (let url of urls) {
        if (this.links.indexOf(url) === -1) {
          this.attachLink(url);
        }
      }
    }

    this.links = urls;
    for (let attachment of this.attachments) {
      if (attachment.type != 'link')
        continue;

      if (this.links.indexOf(attachment.url) === -1) {
        this.links.push(attachment.url);
      }
    }
  }

  deleteAttachment(id) {
    let $attachmentElm = this.elements.attachments.find('[data-id=' + id + ']');
    let attachment = this.getAttachment(id);
    
    $attachmentElm.remove();
    if (!attachment)
      return false;
    this.removeSubmitBlocker("attachment-" + attachment.id);
    if (attachment.committed) {
      attachment.delete = true;
      attachment.committed = false;
    } else {
      let index = this.attachments.indexOf(attachment);
      this.attachments.splice(index, 1);
    }
    this.scanLinks();
    return true;
  }
  getAttachment(id) {
    for (let attachment of this.attachments) {
      if (attachment.id == id)
        return attachment;
    }

    return false;
  }
  /**
   * Lisää uuden liitetiedoston input-elementistä
   * 
   * @param inputElm 
   */
  attachImage(inputElm) {
    let that = this;
    if (!inputElm.files || !inputElm.files[0])
      return false;
    let id = Math.random().toString(16).substr(2, 8);
    
    
    
    //this.formData.append('files[]', inputElm.files[0], inputElm.files[0].name);
    
    
    var reader = new FileReader();
    
    
    let imageFile = inputElm.files[0];
    this.addSubmitBlocker("attachment-" + id);
    reader.onload = function(e: any) {
      var rendered = that.templates['image'].render({ id: id, url: e.target.result});
      rendered.appendTo(that.elements.imageAttachmentsList);
      that.attachments.push({
        id: id,
        committed: false,
        delete: false,
        type: "image",
        file: imageFile,
        elm: rendered
      });

      that.removeSubmitBlocker("attachment-" + id);
    };
    reader.readAsDataURL(inputElm.files[0]);
  }

  attachLink(url) {
    let that = this;
    console.log('Linkitetään', url);
    if (!url)
      return false;

    let id = Math.random()
      .toString(16)
      .substr(2, 8);
    let rendered = this.templates['link'].render({ id: id, status: 'loading', image: '', title: '', description: ''});
    rendered.appendTo(this.elements.linkAttachmentsList);

    let attachment = {
      id: id,
      committed: false,
      delete: false,
      type: 'link',
      elm: rendered,
      url: url,
      image: null,
      title: null,
      description: null,
    };
    this.addSubmitBlocker("attachment-" + id);
    this.attachments.push(attachment);
    let request = new XMLHttpRequest();
    request.addEventListener('load', function(e) {
      console.log('e', e, request.response);
      let data = JSON.parse(request.response);

      if (data.error) {
        rendered.attr('data-status', 'error');
        rendered.find('.message').text(data.error);
        attachment.delete = true;
      } else {

        rendered.attr('data-status', 'loaded');
        
        
        rendered.find('.host').text('' + data.host);
        rendered.find('a').attr('href', data.url);

        rendered.find('.title').text(data.title);
        rendered.find('.description').text(data.description);

        attachment.title = data.title;
        attachment.description = data.description;

        if (data.images.length) {
          rendered.find('.preview-image img').attr('src', data.images[0]);
          attachment.image = data.images[0];
        }
      }
      that.removeSubmitBlocker("attachment-" + id);
    });
    request.open('GET', '/api/activity-feed/link-preview/' + encodeURIComponent(url));
    request.send();
  }

  submit() {
    
    let that = this;
    let formData = new FormData();
    let fields:any = {};
    for (let field of this.elements.form.serializeArray()) {
      fields[field.name] = ('' + field.value).trim();
    }
    
    if (!fields.content) {
      alert('Et voi julkaista tyhjää seinäkirjoitusta');
      return false;
    }
    if (this.submitBlockers.length) {
      alert('Odota esikatselun latautumista ennen tallentamista');
      return false;
    }

    let exportKeys = {
      image: ['id', 'delete', 'type', 'file'],
      link: ['id', 'delete', 'type', 'url', 'image', 'title', 'description'],
    };
    for (let attachment of this.attachments) {
      let id = attachment.id;
      if (attachment.committed)
        continue;

      if (!exportKeys[attachment.type])
        continue;
      
      for (let key of exportKeys[attachment.type]) {
        let value = attachment[key];
        if (value === true || value === false)
          value = value ? 1 : 0;
        if (value === null)
          value = '';

        formData.set("attachments[" + id + "][" + key + "]", value);
      }
    }
    
    for (let key in fields) {

      formData.set(key, fields[key]);
    }

    let request = new XMLHttpRequest();
    request.addEventListener('progress', console.log);
    request.addEventListener('load', function() {
      that.close();
      
      if (that.id)
        ActivityFeed.refreshEntry(that.id);

    });

    request.open('POST', this.elements.form.attr('action'));
    request.send(formData);
    
  }

  close() {
    if (this.options.thickbox)
      jQuery('#TB_overlay').click();
    else
      window.location.reload();
  }

}